import React from "react";

const HeaderCardComponent = ({ fieldName, value }) => {
  if (fieldName.startsWith("ELL")) {
    return null;
  }
  // Skip values that are objects/arrays — they are table data, not header fields
  if (value !== null && typeof value === "object") {
    return null;
  }
  return (
    <div className="flex-container2">
      <div className="flex-item-left">{fieldName}</div>
      <div className="flex-item-right">{value}</div>
    </div>
  );
};

export default HeaderCardComponent;
